import { render, staticRenderFns } from "./MenuScreen.vue?vue&type=template&id=66f071b3&scoped=true&"
import script from "./MenuScreen.vue?vue&type=script&lang=js&"
export * from "./MenuScreen.vue?vue&type=script&lang=js&"
import style0 from "./MenuScreen.vue?vue&type=style&index=0&id=66f071b3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f071b3",
  null
  
)

export default component.exports